import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject, ViewChild, Renderer2 } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OrderProductService } from '../order-product.service';
import { OrderProduct } from '../order-product';
import { PropertyService } from '@app/_components/property/property.service';
import { OrderProductShortTermRentalJoinService } from '@app/_components/order-products-short-term-rental-join/order-products-short-term-rental-join.service';
import { PickList } from 'primeng/picklist';

@Component({
    selector: 'app-order-product',
    templateUrl: './order-product.component.html',
    styleUrls: ['./order-product.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OrderProductComponent implements OnInit {
	@ViewChild('pickList') pickList: PickList;
	feeTypes: any;
	feeFrequencies: any;
	properties: any[]=[];
	sourceProperties: any[]=[];
	targetProperties: any[]=[];
	orderProductShortTermRentalJoins: any[]=[];
	isDataLoaded = false;
	applyStaysOfNtsList: any[]=[];
	targetPropertyLength: number;
	shortTermRentalIds: any[]=[];
	orderProductObj: any[]=[];
	isSearching = false;filters: any;
	selectedFilter: any;
	// Date: 2026-04-09 Author: Alkesh PCT applied-to options
	valuePCTAppliedToOptions: any[] = [];

	constructor(
		private primengConfig: PrimeNGConfig,
		private renderer: Renderer2,
		private orderProductService: OrderProductService,
		private orderProductShortTermRentalJoinService: OrderProductShortTermRentalJoinService,
		private propertyService: PropertyService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.orderProduct = data.orderProduct,
			this.statuses = orderProductService.statuses;
			this.feeTypes = orderProductService.feeTypes;
			this.feeFrequencies = orderProductService.feeFrequencies;
			this.filters = orderProductService.filters;
			this.selectedFilter = "propertyCode";
			this.applyStaysOfNtsList = orderProductService.applyStaysOfNtsList;
			this.valuePCTAppliedToOptions = orderProductService.valuePCTAppliedToOptions;
	}

	@Input() orderProduct: OrderProduct;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	orderProductId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'orderProductId': [],
		'name': [{ type: 'required', message: 'Required' }],
		'description': [],
		'privateNotes': [],
		'wholesalePrice': [],
		'listPrice': [],
		'listPriceAdjustmentPercent': [],
		'listPriceAdjustmentAmount': [],
		'cashPaymentAdjustmentTarget': [],
		'salesTaxable': [],
		'roomTaxable': [],
		'value': [],
		'type': [],
		'productCode': [],
		'productGroup': [],
		// applyToAllUnit: [],
		feeUniquePerUnit: [],
		feeType: [],
		// active: [],
		addToRate: [],
		feeFrequency: [],
		showToCustomer: [],
		useBookingRule: [],
		applyStaysOfAtLeastNts: [],
		applyStaysOfLessThanNts: []
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		this.fetchProperties();
		// if we were passed the whole orderProduct object
		if (this.orderProduct) {
			this.orderProductId = this.orderProduct.orderProductId;
			this.fixDates();
			this.form1.patchValue(this.orderProduct);
		}
		this.primengConfig.ripple = true;
	}
	// this.propertyService.findAllSummaryWithStatusActiveAndSuspended()
	fetchProperties() {
		try {
			this.propertyService.propertySummaryForShortData()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.properties = res.data.properties;
						if (this.orderProduct) {
							this.orderProductId = this.orderProduct.orderProductId;
							this.fetchOrderProductShortTermRentalJoinByOrderProductId();
						}

						return this.properties;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	fetchOrderProductShortTermRentalJoinByOrderProductId() {

		try {
			this.orderProductShortTermRentalJoinService.getAllByOrderProductId(this.orderProductId)
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.orderProductShortTermRentalJoins = res.data.orderProductShortTermRentalJoins;
						// this.isDataLoaded = false;
						this.targetProperties = [];
						this.sourceProperties = [];

						this.properties.forEach(property => {
							const orderProductHaveProperty = this.orderProductShortTermRentalJoins.find((e: any) => e.shortTermRentalId == property.shortTermRentalId);
							if(orderProductHaveProperty != null) {
								this.targetProperties.push(property);
							}else{
								this.sourceProperties.push(property);
							}
						});
						this.isDataLoaded = true;
						this.primengConfig.ripple = true;

						// return this.orderProductShortTermRentalJoins;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.orderProductId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		// Guard: prevent duplicate POSTs when the server is slow or returns 504
		if (this.formLoading) { return; }
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.orderProductService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderProduct = res.data.orderProduct;
						this.doAdd.emit(this.orderProduct);
					},
					(err: any) => {
						console.log('orderProduct-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		// Guard: prevent duplicate PATCHes when the server is slow or returns 504
		if (this.formLoading) { return; }
		console.log('orderProduct: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.orderProductService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.orderProduct = res.data.orderProduct;
						this.doUpdate.emit(this.orderProduct);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.orderProductService.delete(this.orderProduct.orderProductId)
				.subscribe(
					(res: any) => {
						console.log('orderProduct-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.orderProduct);
					},
					(err: any) => {
						console.log('orderProduct-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			orderProductId: [this.orderProductId],
			name: ['', Validators.required],
			description: [],
			privateNotes: [],
			wholesalePrice: [],
			listPrice: [],
			listPriceAdjustmentPercent: [],
			listPriceAdjustmentAmount: [],
			cashPaymentAdjustmentTarget: [],
			salesTaxable: [],
			roomTaxable: [],
			value: [],
			type: [],
			productCode: [],
			productGroup: [],
			// applyToAllUnit: [],
			feeUniquePerUnit: [],
			feeType: [1],
			// active: [],
			addToRate: [],
			feeFrequency: [],
			useBookingRule: [],
			showToCustomer: [],
			applyStaysOfAtLeastNts: [],
			applyStaysOfLessThanNts: [],
			valuePCTAppliedTo: [1],    // default: Invoice Grand Total
			isAddPCTIntoLOS: [false]   // default: false

		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.orderProduct.orderProductDate = moment(this.orderProduct.orderProductDate).toDate();
	}


	moveAllToTarget(event: any){
		this.orderProductObj = [];
		event.items.forEach(property => {
			const dataObj = {
				"orderProductId":this.orderProductId,
				"shortTermRentalId":property.shortTermRentalId,
				"valueAMT":this.form1.value.listPrice,
				"valuePCT":this.form1.value.listPriceAdjustmentPercent,
				"feeType":this.form1.value.feeType != undefined ? this.form1.value.feeType : 1,
				// "active":this.form1.value.active != undefined ? this.form1.value.active : false,
				"addToRate":this.form1.value.addToRate != undefined ? this.form1.value.addToRate : false,
				"opsNotes":null,
				"showToCustomer":this.form1.value.showToCustomer != undefined ? this.form1.value.showToCustomer : false,
				"feeFrequency":this.form1.value.feeFrequency != undefined ? this.form1.value.feeFrequency : 1,
				"useBookingRule": this.form1.value.useBookingRule != undefined ? this.form1.value.useBookingRule : false,
				"applyStaysOfAtLeastNts": this.form1.value.applyStaysOfAtLeastNts,
				"applyStaysOfLessThanNts": this.form1.value.applyStaysOfLessThanNts,
				"valuePCTAppliedTo": this.form1.value.valuePCTAppliedTo != undefined ? this.form1.value.valuePCTAppliedTo : 1,
				"isAddPCTIntoLOS": this.form1.value.isAddPCTIntoLOS != undefined ? this.form1.value.isAddPCTIntoLOS : false,
			}
			this.orderProductObj.push(dataObj)
		});
		this.formAddOrderProductShortTermRentalJoin(this.orderProductObj);
    }

	moveToTarget(event: any){
		this.orderProductObj = [];
		event.items.forEach(property => {
			const dataObj = {
				"orderProductId":this.orderProductId,
				"shortTermRentalId":property.shortTermRentalId,
				"valueAMT":this.form1.value.listPrice,
				"valuePCT":this.form1.value.listPriceAdjustmentPercent,
				"feeType":this.form1.value.feeType != undefined ? this.form1.value.feeType : 1,
				// "active":this.form1.value.active != undefined ? this.form1.value.active : false,
				"addToRate":this.form1.value.addToRate != undefined ? this.form1.value.addToRate : false,
				"opsNotes":null,
				"showToCustomer":this.form1.value.showToCustomer != undefined ? this.form1.value.showToCustomer : false,
				"feeFrequency":this.form1.value.feeFrequency != undefined ? this.form1.value.feeFrequency : 1,
				"useBookingRule": this.form1.value.useBookingRule != undefined ? this.form1.value.useBookingRule : false,
				"applyStaysOfAtLeastNts": this.form1.value.applyStaysOfAtLeastNts,
				"applyStaysOfLessThanNts": this.form1.value.applyStaysOfLessThanNts,
				"valuePCTAppliedTo": this.form1.value.valuePCTAppliedTo != undefined ? this.form1.value.valuePCTAppliedTo : 1,
				"isAddPCTIntoLOS": this.form1.value.isAddPCTIntoLOS != undefined ? this.form1.value.isAddPCTIntoLOS : false,
			}
			this.orderProductObj.push(dataObj)
		});
		this.formAddOrderProductShortTermRentalJoin(this.orderProductObj);
    }

	moveAllToSource(event: any){
		this.shortTermRentalIds = [];
		event.items.forEach(property => {
			this.shortTermRentalIds.push(property.shortTermRentalId)
		});
		this.deleteOrderProductShortTermRentalRelationship(this.shortTermRentalIds);
    }
    moveToSource(event: any){
		this.shortTermRentalIds = [];
		event.items.forEach(property => {
			this.shortTermRentalIds.push(property.shortTermRentalId)
		});
		this.deleteOrderProductShortTermRentalRelationship(this.shortTermRentalIds);
    }

	deleteOrderProductShortTermRentalRelationship(shortTermRentalIds: any[]) {
		this.isSearching = true;
		try {
			this.orderProductShortTermRentalJoinService.deleteOrderProductShortTermRentalsRelationship(this.orderProductId, shortTermRentalIds)
				.subscribe(
					(res: any) => {
						this.isSearching = false;
						// console.log('orderProductShortTermRentalJoin-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Successfully move into Available Units" });
						this.targetPropertyLength = this.targetProperties.length;
					},
					(err: any) => {
						this.isSearching = false;
						console.log('orderProductShortTermRentalJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });
		} catch (error) {
			this.isSearching = false;
			this.alertService.error(error);
		}
	}

	formAddOrderProductShortTermRentalJoin(orderProductObj: any[]) {
		this.isSearching = true;
		try {
			this.orderProductShortTermRentalJoinService.addAll(orderProductObj)
				.subscribe(
					(res: any) => {
						this.isSearching = false;
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: "Successfully move into Selected Units" });
						this.targetPropertyLength = this.targetProperties.length;
						let orderProductShortTermRentalJoin = res.data.orderProductShortTermRentalJoin;
					},
					(err: any) => {
						this.isSearching = false;
						console.log('orderProductShortTermRentalJoin-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });

		} catch (error) {
			this.isSearching = false;
			this.alertService.error(error);
		}
	}

	reloadProperties(event: any){
		// this.sourceProperties = [];
		// this.targetProperties.splice
		const index = this.targetProperties.findIndex(x => x.shortTermRentalId === event.shortTermRentalId);
		this.sourceProperties.push(this.targetProperties[index]);
		this.targetProperties.splice(index);
		const dataTableRef = this.renderer.selectRootElement(this.pickList.el.nativeElement, true);
    dataTableRef.focus();
	this.fetchOrderProductShortTermRentalJoinByOrderProductId();

	}

	selectedFilters(event: any){
		this.selectedFilter = event.value;
	}


}
